import useSWRMutation from 'swr/mutation';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import resetSession from 'utils/functions/resetSession';

export function useLogout() {
  return useSWRMutation<null, Error, string>(
    '/api/v1/auth/logout/',
    async () => {
      try {
        const response = await letrusAPI('/api/v1/auth/logout/', {
          method: 'post',
          skipAuthRefresh: true,
        });

        resetSession();
        window.location.pathname = '/login';

        return response.data;
      } catch (error) {
        // temporarily dealing with error as sucess due to backend missconfig of endpoint

        resetSession();
        window.location.pathname = '/login';
      }
    },
    {
      throwOnError: false,
    },
  );
}
